module.exports = __webpack_public_path__ + "static/media/cryptocurrencies.96e45d69.png";